<div class="content">
    <div class="section-tab">
        <div class="row-header">
            <div class="col-header">Service Event ID</div>
            <div class="col-header">Source System ID</div>
            <div class="col-header">Source System Name</div>
            <div class="col-header">Event Date</div>
            <div class="col-header">Report Url</div>
            <div class="col-header">Comment</div>
            <div class="col-header">Service Category</div>
            <div class="col-header">Service Engineer</div>
            <div class="col-header">Modified date</div>
        </div>
        <div class="row" *ngFor="let serviceEvent of serviceEvents">
            <div class="col">{{ serviceEvent.id }}</div>
            <div class="col">{{serviceEvent.sourceSystemId}}</div>
            <div class="col">{{ serviceEvent.sourceSystemName }}</div>
            <div class="col">{{ serviceEvent.eventDate | mibDate }}</div>
            <div class="col" matTooltip="{{ serviceEvent.reportUrl | reportUrl }}"
                 [matTooltipPosition]="'above'">
                <a *ngIf="serviceEvent.reportUrl" href="{{ serviceEvent.reportUrl | reportUrl }}" target="_blank"
                    [class.disable-report-url]="serviceEvent.reportUrl | isNotReportUrl">Go to report</a>
            </div>
            <div class="col">{{ serviceEvent.comment }}</div>
            <div class="col">{{ serviceEvent.serviceCategoryName }}</div>
            <div class="col">{{ serviceEvent.serviceEngineerName }}</div>
            <div class="col">{{ serviceEvent.modifiedDate | mibDateTime }}</div>
        </div>
    </div>
</div>